import { IIndicator, IInsight } from '@jumpstart/core';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { Formik } from 'formik';
import React, { Fragment, useRef } from 'react';
import * as yup from 'yup';
import ScoutTooltip from '../../../widgets/ScoutTooltip';
import ContentPreviewIndicator from './ContentPreviewIndicator';
import ContentPreviewLoading from './ContentPreviewLoading';
import IndicatorForm from './IndicatorForm';
import { IValidation } from './utils';


const indicatorFormSchema = yup.object({
  name: yup
    .string()
    .required('Name is required'),
  description: yup
    .string()
    .nullable(),
  index: yup.number().nullable()
});

export interface IIndicatorEditor {
  showPreview?: boolean;
  event: IInsight;
  indicator: IIndicator & {index?: number};
  loading: boolean;
  max: number;
  validation: IValidation;

  onError?(err: Error): void;

  onSubmit?(indicator: IIndicator & { index?: number }): void;
}

export default function IndicatorEditor(props: IIndicatorEditor) {
  const { indicator, event, showPreview, max, onSubmit, loading, validation } = {showPreview: true, ...props};
  const frameContainer = useRef<any>(null);

  return (
    <Grid container direction="column" style={{ padding: 24 }}>
      <Formik
        initialValues={indicator}
        validationSchema={indicatorFormSchema}
        onSubmit={(values: IIndicator & { index?: number }) => {
          if (onSubmit) {
            const scrubbed: IIndicator = {
              ...values,
              id: indicator.id
            };
            onSubmit(scrubbed);
          } else {
            console.error('onSubmit missing');
          }
        }}
      >
        {
          (formikProps) => (

            <Grid container direction="row" justifyContent="space-between" wrap="nowrap">
              <Grid item xs={showPreview ? 5 : 12}>
                <Paper style={{ height: '100%', padding: 24 }}>
                  <Grid item>
                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 8 }}>
                      <Typography variant="h6" style={{ marginRight: 8 }}>Indicator Form</Typography>
                    </Grid>
                  </Grid>

                  <IndicatorForm {...formikProps} max={max} validation={validation}/>
                </Paper>
              </Grid>
              {showPreview && <Fragment>

              <Grid item xs={2}>
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  justifyContent="space-around"
                  style={{ height: '100%' }}
                >
                  {[1].map((i) =>
                    <Grid item key={`reload-${i}`}>
                      <ScoutTooltip title="Save and reload changes">
                        <IconButton
                          size="medium"
                          onClick={() => formikProps.handleSubmit()}
                        >
                          <DoubleArrowIcon fontSize="large"/>
                        </IconButton>
                      </ScoutTooltip>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={5} ref={frameContainer}>
                <Paper style={{ height: '100%' }}>
                  {frameContainer.current && (loading ? <ContentPreviewLoading
                    width={frameContainer.current.offsetWidth}
                    height={frameContainer.current.offsetHeight}
                  /> : <ContentPreviewIndicator
                    event={event}
                    indicator={indicator}
                    title={`${event.name} >> ${indicator.name}`}
                    width={frameContainer.current.offsetWidth}
                    height={frameContainer.current.offsetHeight}
                  />)}
                </Paper>
              </Grid>
              </Fragment>}
            </Grid>
          )}
      </Formik>
    </Grid>
  );
}
